module.exports = __webpack_public_path__ + "static/media/github.f2948be7.svg";